function getStoredToken() {
  if (typeof localStorage === "undefined") {
    return null;
  }

  return localStorage.getItem("token");
}

export function authHeaders(headers = {}) {
  const token = getStoredToken();

  if (!token) {
    return headers;
  }

  return {
    ...headers,
    Authorization: `Bearer ${token}`,
  };
}

export async function handleResponse(response) {
  if (response.ok) return response.json();
  if (response.status === 401) {
    if (typeof localStorage !== "undefined") {
      localStorage.removeItem("token");
    }
    throw new Error("Unauthorized");
  }
  if (response.status === 400) {
    // So, a server-side validation error occurred.
    // Server side validation returns a string error message, so parse as text instead of json.
    const error = await response.text();
    throw new Error(error);
  }
  const error = await response.text();
  throw new Error(`Network response was not ok. status:${response.status} error:${error}`);
}

// In a real app, would likely call an error logging service.
export function handleError(error) {
  // eslint-disable-next-line no-console
  console.error(`API call failed. ${error}`);
  throw error;
}
